import { useProfile } from './useProfile';

export type Role =
  | 'executive-admin'
  | 'admin'
  | 'leader'
  | 'master'
  | 'user'
  | 'approver'
  | 'sequential-approver';

export const RoleMap: Record<Role, Role> = {
  'executive-admin': 'executive-admin',
  admin: 'admin',
  leader: 'leader',
  master: 'master',
  user: 'user',
  approver: 'approver',
  'sequential-approver': 'sequential-approver',
};

export const useGetRole = (): Role[] | undefined => {
  const { profile, loading } = useProfile();

  if (loading) return;

  if (!profile) return [RoleMap.user];


  if (profile.isLeader) return [RoleMap.leader];

  if (profile.isSequentialApprover && profile.role.includes(RoleMap.user)) return [RoleMap['sequential-approver']];
  return profile.role;
};
